import { render, staticRenderFns } from "./ControlSidebar.vue?vue&type=template&id=55bc9a43&scoped=true&"
import script from "./ControlSidebar.vue?vue&type=script&lang=js&"
export * from "./ControlSidebar.vue?vue&type=script&lang=js&"
import style0 from "./ControlSidebar.vue?vue&type=style&index=0&id=55bc9a43&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55bc9a43",
  null
  
)

export default component.exports